import { FuseResult, FuseResultMatch, RangeTuple } from 'fuse.js';

export const highlight = <T>(
  fuseSearchResult: FuseResult<T>[],
  highlightClassName = 'highlight'
): T[] => {
  const set = (obj: any, path: string | undefined, value: any) => {
    const pathSteps = path?.split('.');
    let currentObj: any = obj;

    if (!pathSteps) {
      return;
    }

    for (let i = 0; i < pathSteps.length - 1; i++) {
      currentObj = currentObj[pathSteps[i]];
    }

    currentObj[pathSteps[pathSteps.length - 1]] = value;
  };

  const generateHighlightedText = (
    inputText: string | undefined,
    regions: readonly RangeTuple[] = []
  ): string => {
    let highlightedContent = '';
    let nextUnhighlightedRegionStart = 0;

    regions.forEach(([start, end]) => {
      const nextUnhighlightedSegment = inputText?.substring(
        nextUnhighlightedRegionStart,
        start
      );
      const highlightedSegment = inputText?.substring(start, end + 1);

      highlightedContent += `${nextUnhighlightedSegment}<span class="${highlightClassName}">${highlightedSegment}</span>`;
      nextUnhighlightedRegionStart = end + 1;
    });

    highlightedContent += inputText?.substring(nextUnhighlightedRegionStart);
    return highlightedContent;
  };

  return fuseSearchResult
    .filter(({ matches }) => matches && matches.length)
    .map(({ item, matches }) => {
      const highlightedItem = { ...item };

      matches?.forEach((match: FuseResultMatch) => {
        return set(
          highlightedItem,
          match.key,
          generateHighlightedText(match.value, match.indices)
        );
      });

      return highlightedItem;
    });
};
